import {
	SCRIPT_DATES_ERROR,
	SCRIPT_DATES_COUNT,
	SCRIPT_DATES_GET,
	SCRIPT_DATES_GET_ALL,
	SCRIPT_DATES_SAVE,
	SCRIPT_DATES_ADD_UPDATE,
	SCRIPTS_DATE_CLEAR,
	SCRIPT_DATES_CLEAR_ALL_UPDATES,
	SCRIPT_DATES_REMOVE_ALL_EDITS,
	SCRIPT_DATES_GET_REFINE,
	SCRIPT_DATES_REFINE_CLEAR,
	SCRIPT_DATES_GET_GROUP_UPDATER,
	SCRIPT_DATES_GROUP_UPDATER_FILTER,
	SCRIPT_DATES_GROUP_UPDATER_UPDATES,
	SCRIPT_DATES_GROUP_UPDATER_CLEAR,
	SCRIPT_DATES_REFINE_FILTERS_CLEAR
} from '../Enums/Script.Dates.Enums';

const initState = {
	data: [],
	dataCopy: [],
	all_data: [],
	errors: [],
	updated: [],
	hasUpdates: false,
	count: { total: 0, complete: 0 },
	isLoaded: false,
	message: '',
	dataTableTotal: 0,
	selectedTypes: [],
	selectedTeamIds: [],
	refineData: [],
	refineFields: [{ title: '', markingTeamCode: '', markingMethod: [], scriptDeliveryDate: '', scriptReturnDate: '', eMarkingStartDate: '', eMarkingEndDate: ''}],
	groupUpdaterData: [],
	groupUpdaterFields: [{ isGroupUpdater: false, previewUpdate: [], isGroupUpdaterFilter: false }],
	groupUpdaterTypes: [],
	groupUpdaterTeamIds: []
};

const scriptdates = (state = initState, action) => {
	let updatedState = {};
	const { type, payload } = action;

	switch (type) {
		case SCRIPT_DATES_COUNT:
			updatedState = {
				...state,
				count: payload.data,
				errors: payload.errors,
				isLoaded: true
			};
			break;
		case SCRIPT_DATES_ERROR:
			updatedState = { ...state, errors: payload.errors, isLoaded: true };
			break;
		case SCRIPT_DATES_GET:
			updatedState = {
				...state,
				data: payload.data,
				dataCopy: payload.dataCopy,
				errors: payload.errors,
				dataTableTotal: payload.dataTableTotal,
				selectedTypes: payload.selectedTypes,
				selectedTeamIds: payload.selectedTeamIds,
				refineFields: payload.refineFields,
				groupUpdaterFields: payload.groupUpdaterFields
			};
			break;
		case SCRIPT_DATES_ADD_UPDATE:
			updatedState = {
				...state,
				updated: action.payload.updates,
				hasUpdates: state.updated.length > 0 || action.payload.updates.length > 0
			};
			break;
		case SCRIPT_DATES_GET_ALL:
			updatedState = {
				...state,
				all_data: action.payload.data,
				errors: action.payload.errors
			};
			break;
		case SCRIPT_DATES_SAVE: {
			let { message, data, errors, groupUpdaterData } = payload;
			updatedState = {
				...state,
				hasUpdates: false,
				errors,
				message,
				data: state.data.map(origItem => {
					let updatedItem = data.find(item => item.markingTeamId === origItem.markingTeamId);
					if (updatedItem) {
						updatedItem = { ...origItem, ...updatedItem };
						const keys = Object.keys(origItem);
						const updatedResult = {};
						keys.forEach(key => (updatedResult[key] = updatedItem[key]));
						return updatedResult;
					}
					return origItem;
				}),
				updated: [],
				groupUpdaterData
			};
			break;
		}
		case SCRIPTS_DATE_CLEAR: {
			const { errors } = action.payload;
			updatedState = {
				...state,
				errors,
				message: '',
				updated: []
			};
			break;
		}
		case SCRIPT_DATES_CLEAR_ALL_UPDATES: {
			updatedState = {
				...state,
				updated: [],
				hasUpdates: false,
				dataTableTotal: 0,
				selectedTypes: [],
				selectedTeamIds: [],
				refineData: [],
				refineFields: [{ title: '', markingTeamCode: '', markingMethod: [], scriptDeliveryDate: '', scriptReturnDate: '', eMarkingStartDate: '', eMarkingEndDate: ''}],
				groupUpdaterData: [],
				groupUpdaterFields: [{ isGroupUpdater: false, previewUpdate: [], isGroupUpdaterFilter: false }],
				groupUpdaterTypes: [],
				groupUpdaterTeamIds: [],
				errors: [],
				message: ''
			};
			break;
		}
		case SCRIPT_DATES_REMOVE_ALL_EDITS: {
			updatedState = {
				...state,
				data: payload.data,
				updated: [],
				hasUpdates: false
			};
			break;
		}
		case SCRIPT_DATES_GET_REFINE: {
			const { refineData, errors } = payload;
			updatedState = {
				...state,
				refineData,
				errors,
			};
			break;
		}
		case SCRIPT_DATES_REFINE_CLEAR:
			updatedState = {
				...state,
				refineData: []
			};
			break;
		case SCRIPT_DATES_GET_GROUP_UPDATER:
			const { groupUpdaterData, errors } = payload;
			updatedState = {
				...state,
				groupUpdaterData,
				errors
			};
			break;
		case SCRIPT_DATES_GROUP_UPDATER_FILTER:
			updatedState = {
				...state,
				groupUpdaterTypes: payload.groupUpdaterTypes,
				groupUpdaterTeamIds: payload.groupUpdaterTeamIds
			};
			break;
		case SCRIPT_DATES_GROUP_UPDATER_UPDATES:
			updatedState = {
				...state,
				groupUpdaterData: payload.groupUpdaterData
			};
			break;
		case SCRIPT_DATES_GROUP_UPDATER_CLEAR:
			updatedState = {
				...state,
				groupUpdaterData: [],
				groupUpdaterFields: [{ isGroupUpdater: false, previewUpdate: [], isGroupUpdaterFilter: false }],
				groupUpdaterTypes: [],
				groupUpdaterTeamIds: [],
				errors: [],
				message: ''
			};
			break;
		case SCRIPT_DATES_REFINE_FILTERS_CLEAR:
			updatedState = {
				...state,
				refineFields: [{ title: '', markingTeamCode: '', markingMethod: [], scriptDeliveryDate: '', scriptReturnDate: '', eMarkingStartDate: '', eMarkingEndDate: ''}]
			};
			break;
		default:
			return state;
	}
	return updatedState;
};

export default scriptdates;
